import React from 'react';
import AttachmentCardComponent, { type AttachmentRow } from './AttachmentCard';
import type { ContextItem } from '../../store/chatStore';

import { useTranslation } from 'react-i18next';

type RiskAttachment = {
  id?: string;
  riskTypeId?: string;
  asset?: {
    id?: string;
    name?: string;
    region?: string;
    resourceType?: string;
  };
};

export const RiskContext: React.FC<{
  item: ContextItem;
  onRemove: () => void;
}> = ({ item, onRemove }) => {
  const { t } = useTranslation('pleri/chat');
  const risk = item.attachmentMetaData as RiskAttachment | undefined;
  const rows: Array<AttachmentRow> = [];

  if (risk?.asset?.resourceType) {
    rows.push({ label: t('resource'), value: risk.asset.resourceType });
  }
  if (risk?.asset?.region) {
    rows.push({ label: t('region'), value: risk.asset.region });
  }

  return (
    <AttachmentCardComponent
      icon={item.icon}
      title={risk?.asset?.name || t('risk')}
      rows={
        rows.length
          ? rows
          : item.display
            ? [{ label: t('risk'), value: String(item.display) }]
            : []
      }
      onRemove={onRemove}
      removeAriaLabel="Remove risk context"
    />
  );
};

export default RiskContext;
